import { useQuery } from 'react-query';
import { useCampaignsApi } from 'services/api/campaignsApi';

export const useSimulatorMetadata = ({ campaignId, accountId, enabled }) => {
    const { getSimulatorMetadata } = useCampaignsApi();

    return useQuery(
        ['simulatorMetadata', accountId, campaignId],
        async () => getSimulatorMetadata(accountId, campaignId),
        {
            enabled: enabled && !!accountId && !!campaignId,
        }
    );
};
